<div class="sidenav-two-menus">
  <div class="sidenav-small-menu">
    <mat-nav-list class="site-menu" [ngClass]="{'cdd-nav' : isCDDActive, 'bq-nav' : isBQActive}"
      *appRoleBased="[AppRoles.SDDAnalyst, AppRoles.SDDCompliance, AppRoles.SDDBasicUser, AppRoles.CddAnalyst, AppRoles.CddComplianceAnalyst, AppRoles.CddLegalCompliance, AppRoles.CddMTCreator, AppRoles.BqAdministrator, AppRoles.BqCompliance, AppRoles.BqMT, AppRoles.BqSCM, AppRoles.BqExternalUser, AppRoles.SpAdmin, AppRoles.SpApprover, AppRoles.SpManagement, AppRoles.SpCddUser, AppRoles.SpSddUser]">
      <mat-list-item [routerLink]="['/sdd']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }"
        *appRoleBased="[AppRoles.SDDAnalyst, AppRoles.SDDCompliance, AppRoles.SDDBasicUser]">
        <mat-icon matListItemIcon>group_work</mat-icon>
        <div matListItemTitle>SDD</div>
      </mat-list-item>
      <mat-list-item [routerLink]="['/cdd']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }"
        *appRoleBased="[AppRoles.CddAnalyst, AppRoles.CddComplianceAnalyst, AppRoles.CddLegalCompliance, AppRoles.CddMTCreator]">
        <mat-icon matListItemIcon>supervised_user_circle</mat-icon>
        <div matListItemTitle>CDD</div>
      </mat-list-item>
      <mat-list-item [routerLink]="['/bq']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
        <mat-icon matListItemIcon>assignment</mat-icon>
        <div matListItemTitle>BQ</div>
      </mat-list-item>
      <mat-list-item [routerLink]="['/sp']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }"
        *appRoleBased="[AppRoles.SpAdmin, AppRoles.SpApprover, AppRoles.SpManagement, AppRoles.SpCddUser, AppRoles.SpSddUser]">
        <mat-icon matListItemIcon>shield</mat-icon>
        <div matListItemTitle>SP</div>
      </mat-list-item>
    </mat-nav-list>
    <!-- Gated independently of the role-array above: featureFlags.investigations AND a Ciw* role are both required. -->
    <mat-nav-list class="site-menu" *ngIf="showInvestigationsNav">
      <mat-list-item data-testid="investigations-nav-link" [routerLink]="['/investigations']"
        routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
        <mat-icon matListItemIcon>search</mat-icon>
        <div matListItemTitle>CIW</div>
      </mat-list-item>
    </mat-nav-list>
  </div>
  <div class="sidenav-menu">
    <div class="sidenav-top-content">
      <ng-template [ngIf]="isSDDActive">
        <mat-nav-list class="side-navigation">
          @for (menu of sddMenu; track $index) {
          <mat-list-item [routerLink]="menu.link" routerLinkActive="active" (click)="onMenuClick(menu)"
            *appRoleBased="menu.roles">
            <mat-icon matListItemIcon [svgIcon]="menu.svgIcon"></mat-icon>
            <div matListItemTitle [matTooltip]="menu.name | translate" [matTooltipDisabled]="!menu.showTooltip">
              {{ menu.name | translate }}
            </div>
          </mat-list-item>
          }
        </mat-nav-list>
      </ng-template>
      <ng-template [ngIf]="isCDDActive">
        <ng-container
          *appRoleBased="[AppRoles.CddAnalyst, AppRoles.CddComplianceAnalyst, AppRoles.CddLegalCompliance, AppRoles.CddMTCreator]">
          <h3>{{'sideMenu.customers' | translate}}</h3>
          <mat-nav-list class="side-navigation cdd-nav">
            @for (menu of cddMenuCustomers; track $index) {
            <mat-list-item [routerLink]="menu.link" routerLinkActive="active" (click)="onMenuClick(menu)"
              *appRoleBased="menu.roles">
              <mat-icon matListItemIcon [svgIcon]="menu.svgIcon"></mat-icon>
              <div matListItemTitle [matTooltip]="menu.name | translate" [matTooltipDisabled]="!menu.showTooltip">
                {{ menu.name | translate }}
              </div>
            </mat-list-item>
            }
          </mat-nav-list>

          <h3
            *appRoleBased="[AppRoles.CddAnalyst, AppRoles.CddComplianceAnalyst, AppRoles.CddLegalCompliance]">
            {{'sideMenu.operations' | translate}}
          </h3>
          <mat-nav-list class="side-navigation cdd-nav">
            @for (menu of cddMenuOperations; track $index) {
            <mat-list-item [routerLink]="menu.link" routerLinkActive="active" (click)="onMenuClick(menu)"
              *appRoleBased="menu.roles">
              <mat-icon matListItemIcon [svgIcon]="menu.svgIcon"></mat-icon>
              <div matListItemTitle [matTooltip]="menu.name | translate" [matTooltipDisabled]="!menu.showTooltip">
                {{ menu.name | translate }}
              </div>
            </mat-list-item>
            }
          </mat-nav-list>
        </ng-container>
      </ng-template>
      <ng-template [ngIf]="isBQActive">
        <mat-nav-list class="side-navigation bq-nav">
          @for (menu of bqMenu; track $index) {
          <mat-list-item [routerLink]="menu.link" routerLinkActive="active" (click)="onMenuClick(menu)"
            *appRoleBased="menu.roles">
            <mat-icon matListItemIcon [svgIcon]="menu.svgIcon"></mat-icon>
            <div matListItemTitle [matTooltip]="menu.name | translate" [matTooltipDisabled]="!menu.showTooltip">
              {{ menu.name | translate }}
            </div>
          </mat-list-item>
          }
        </mat-nav-list>
      </ng-template>
      <ng-template [ngIf]="isSPActive">
        <mat-nav-list class="side-navigation">
          @for (menu of spMenu; track $index) {
          <mat-list-item [routerLink]="menu.link" routerLinkActive="active" (click)="onMenuClick(menu)"
            *appRoleBased="menu.roles">
            <mat-icon matListItemIcon [svgIcon]="menu.svgIcon"></mat-icon>
            <div matListItemTitle [matTooltip]="menu.name | translate" [matTooltipDisabled]="!menu.showTooltip">
              {{ menu.name | translate }}
            </div>
          </mat-list-item>
          }
        </mat-nav-list>
      </ng-template>
      <ng-template [ngIf]="isInvestigationsActive">
        <mat-nav-list class="side-navigation">
          @for (menu of ciwMenu; track $index) {
          <mat-list-item [routerLink]="menu.link" routerLinkActive="active" (click)="onMenuClick(menu)">
            <mat-icon matListItemIcon [svgIcon]="menu.svgIcon"></mat-icon>
            <div matListItemTitle [matTooltip]="menu.name | translate" [matTooltipDisabled]="!menu.showTooltip">
              {{ menu.name | translate }}
            </div>
          </mat-list-item>
          }
          <!-- Configuration, not case work: a sibling of the case list, offered to CiwManager only. -->
          @if (showCiwManagerNav) {
            @for (menu of ciwManagerMenu; track menu.id) {
            <mat-list-item [routerLink]="menu.link" routerLinkActive="active" data-testid="rule-sets-nav-link">
              <mat-icon matListItemIcon [svgIcon]="menu.svgIcon"></mat-icon>
              <div matListItemTitle>{{ menu.name | translate }}</div>
            </mat-list-item>
            }
          }
        </mat-nav-list>

        <!-- The open case's companies, listed under All Cases: picking one scopes every tab to it. -->
        @if (caseContext.companies$ | async; as companies) {
          @if (companies.length) {
            <section class="company-nav" data-testid="sidenav-companies" [attr.aria-label]="'ciw.sidenav.companies' | translate">
              @let blockedReason = caseContext.addCompanyBlockedReason$ | async;
              <div class="company-nav-header">
                <h3 class="company-nav-title">
                  {{ 'ciw.sidenav.companies' | translate }}
                  <span class="company-count" data-testid="sidenav-company-count">{{ companies.length }}</span>
                </h3>
                <!-- A disabled button gets no hover, so the tooltip sits on the wrapper; the reason is also the button's description. -->
                <span class="add-company-wrap" data-testid="sidenav-add-company-wrap"
                      [matTooltip]="blockedReason ? (('ciw.addCompany.' + blockedReason) | translate: { max: maxCompanies }) : ''"
                      [matTooltipDisabled]="!blockedReason">
                  <button mat-button type="button" class="add-company" data-testid="sidenav-add-company"
                          [disabled]="!!blockedReason" [attr.aria-describedby]="blockedReason ? 'sidenav-add-company-reason' : null"
                          (click)="openAddCompany()">
                    <mat-icon fontIcon="add" aria-hidden="true"></mat-icon>
                    {{ 'ciw.addCompany.button' | translate }}
                  </button>
                  @if (blockedReason) {
                    <span id="sidenav-add-company-reason" class="cdk-visually-hidden" data-testid="sidenav-add-company-reason">
                      {{ ('ciw.addCompany.' + blockedReason) | translate: { max: maxCompanies } }}
                    </span>
                  }
                </span>
              </div>
              @if (companies.length > 6) {
                <input class="company-search" type="search" data-testid="sidenav-company-search" [value]="companyFilter"
                       [attr.aria-label]="'ciw.sidenav.searchCompanies' | translate"
                       [placeholder]="'ciw.sidenav.searchCompanies' | translate"
                       (input)="companyFilter = $any($event.target).value">
              }
              <ul class="company-list" role="listbox" [attr.aria-label]="'ciw.sidenav.companies' | translate">
                @for (company of visibleCompanies(companies); track company.id) {
                  <li>
                    <button type="button" role="option" class="company-item" data-testid="sidenav-company"
                            [class.company-item--active]="company.id === caseContext.selectedCompanyId"
                            [attr.aria-selected]="company.id === caseContext.selectedCompanyId"
                            (click)="caseContext.select(company.id)">
                      <span class="company-item-text">
                        <span class="company-item-name">{{ company.name }}</span>
                        @if (company.identifier) {
                          <span class="company-item-id">{{ 'ciw.sidenav.bin' | translate }} {{ company.identifier }}</span>
                        }
                      </span>
                      @if (company.collection) {
                        <span class="company-state" [attr.data-state]="company.collection" data-testid="sidenav-company-state"
                              [matTooltip]="('ciw.sidenav.collection.' + company.collection) | translate"
                              [attr.aria-label]="('ciw.sidenav.collection.' + company.collection) | translate">
                          <mat-icon [fontIcon]="collectionIcon(company.collection)" aria-hidden="true"></mat-icon>
                        </span>
                      }
                    </button>
                  </li>
                } @empty {
                  <li class="company-empty" data-testid="sidenav-company-empty">{{ 'ciw.sidenav.noCompanyMatch' | translate }}</li>
                }
              </ul>
            </section>
          }
        }
      </ng-template>
    </div>
    <div class="sidenav-bottom-content">
      <p>{{ isBQActive ? ('appNameBQ' | translate) : isSDDActive ? ('appNameSDD' | translate) : isSPActive ? ('appNameSP' | translate) : isInvestigationsActive ? ('appNameCIW' | translate) : ('appNameCDD' | translate) }}</p>
      <img src="logo.svg" alt="logo" />
      <p class="copyright">&copy;TENGIZCHEVROIL {{ currentYear }}</p>
    </div>
  </div>
</div>